// extracted by css-extract-rspack-plugin
export default {"processRecordBox":"processRecordBox-MHbABj"};